// You can write more code here

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
import { ButtonController } from '@/game/prefabs/GeneralUI/Buttons/ButtonController';
/* END-USER-IMPORTS */

export default class ConfirmButtonLarge extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // buttonBacking
    const buttonBacking = scene.add.nineslice(
      0,
      0,
      'default-button-confirm',
      undefined,
      180,
      24,
      10,
      10,
      10,
      10,
    );
    buttonBacking.scaleX = 2;
    buttonBacking.scaleY = 2;
    this.add(buttonBacking);

    // buttonLabel
    const buttonLabel = scene.add.bitmapText(0, 0, 'Aronui', 'Button');
    buttonLabel.setOrigin(0.5, 0.5);
    buttonLabel.tintTopLeft = 15130076;
    buttonLabel.tintTopRight = 15130076;
    buttonLabel.tintBottomLeft = 15130076;
    buttonLabel.tintBottomRight = 15130076;
    buttonLabel.text = 'Button';
    buttonLabel.fontSize = -14;
    this.add(buttonLabel);

    this.buttonBacking = buttonBacking;
    this.buttonLabel = buttonLabel;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this.buttonLabel.text = this.buttonText;
    this._controller = new ButtonController({
      buttonBacking,
      buttonLabel,
      defaultTexture: 'default-button-confirm',
      hoverTexture: 'default-button-confirm-hover',
      submitTexture: 'default-button-confirm-hover',
      disabledTexture: 'default-button-disabled',
    });
    /* END-USER-CTR-CODE */
  }

  private buttonBacking: Phaser.GameObjects.NineSlice;
  private buttonLabel: Phaser.GameObjects.BitmapText;
  public buttonText: string = 'Yes';

  /* START-USER-CODE */

  private _controller: ButtonController;
  get controller() {
    return this._controller;
  }

  awake() {
    const { buttonBacking, buttonLabel } = this;

    buttonLabel.setText(this.buttonText);

    return { button: buttonBacking, text: buttonLabel };
  }
  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
